import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeadingSection from "../../../../common/pageheading/PageHeadingSection";
import BreadCrum from "../../../../common/BreadCrum/BreadCrum";
import CustomSelect from "../../../../common/formfields/CustomSelect";
import ToggleSwitch from "../../../../common/formfields/ToggleSwitch";
import StepFooter from "../../../../common/stepper/StepFooter";

const AddVehicle = () => {
    const navigate = useNavigate();
    const { tenantId } = useParams();

    const [autoAssign, setAutoAssign] = useState(true);
    const [anprEnabled, setAnprEnabled] = useState(true);
    const [vehicleType, setVehicleType] = useState("Car");
    const [parkingStatus, setParkingStatus] = useState("Active (Whitelisted)");



    const handleConfirm = () => {
        // Mock save action
        navigate(-1);
    };

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto gap-6 pt-4">
            <BreadCrum />
            
            <PageHeadingSection 
                mainHeading="Add Vehicle"
                subHeading={<span>Register a new vehicle for <strong>Centrum IT Services</strong>.</span>}
            />

            <div className="flex flex-col gap-6 max-w-5xl">
                
                {/* Header Stats Box */}
                <div className="grid grid-cols-4 gap-4 p-4 bg-white dark:bg-cardbg border border-gray-200 dark:border-bordercolor rounded-xl shadow-sm">
                    <div>
                        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-1">Tenant</p>
                        <p className="text-sm font-bold text-gray-800 dark:text-textprimary flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-red-500"></span>
                            Centrum IT Services
                        </p>
                    </div>
                    <div>
                        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-1">Allocated Slots</p>
                        <p className="text-sm font-bold text-gray-800 dark:text-textprimary">30 Slots</p>
                    </div>
                    <div>
                        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-1">Available Slots</p>
                        <p className="text-sm font-bold text-green-500">8 Slots Free</p>
                    </div>
                    <div>
                        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-1">Parking Floor</p>
                        <p className="text-sm font-bold text-purple-600 dark:text-purple-400">Basement 1</p>
                    </div>
                </div>

                {/* Vehicle Information section */}
                <div className="p-5 border border-gray-200 dark:border-bordercolor rounded-xl bg-white dark:bg-cardbg">
                    <h3 className="text-sm font-black text-[#0F172A] dark:text-textprimary uppercase tracking-wide">Vehicle Information</h3>
                    <p className="text-xs text-gray-400 mb-5">Enter owner details and vehicle license registration.</p>

                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-700 dark:text-textprimary mb-1.5">
                                Vehicle Registration Number <span className="text-red-500">*</span>
                            </label>
                            <input 
                                type="text"
                                placeholder="E.G. MH-02-CB-1234"
                                className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dashboardbg border border-gray-200 dark:border-bordercolor rounded-lg text-sm focus:outline-none focus:border-blue-500 dark:text-textprimary placeholder-gray-300"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-700 dark:text-textprimary mb-1.5">
                                Vehicle Owner Name <span className="text-red-500">*</span>
                            </label>
                            <input 
                                type="text"
                                placeholder="e.g. Rahul Sharma"
                                className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dashboardbg border border-gray-200 dark:border-bordercolor rounded-lg text-sm focus:outline-none focus:border-blue-500 dark:text-textprimary placeholder-gray-300"
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-700 dark:text-textprimary mb-1.5">
                                Vehicle Type <span className="text-red-500">*</span>
                            </label>
                            <CustomSelect
                                options={[
                                    { label: "Car", value: "Car" },
                                    { label: "Bike", value: "Bike" }
                                ]}
                                value={vehicleType}
                                onChange={setVehicleType}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-700 dark:text-textprimary mb-1.5">
                                Employee ID
                            </label>
                            <input 
                                type="text"
                                placeholder="e.g. EMP-9042"
                                className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dashboardbg border border-gray-200 dark:border-bordercolor rounded-lg text-sm focus:outline-none focus:border-blue-500 dark:text-textprimary placeholder-gray-300"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-700 dark:text-textprimary mb-1.5">
                                Mobile Number
                            </label>
                            <input 
                                type="text"
                                placeholder="+91 98200 12345"
                                className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dashboardbg border border-gray-200 dark:border-bordercolor rounded-lg text-sm focus:outline-none focus:border-blue-500 dark:text-textprimary placeholder-gray-300"
                            />
                        </div>
                    </div>
                </div>

                {/* Parking Assignment */}
                <div className="p-5 border border-gray-200 dark:border-bordercolor rounded-xl bg-white dark:bg-cardbg relative">
                    <div className="absolute right-5 top-5 flex items-center gap-2">
                        <span className="text-xs font-bold text-gray-800 dark:text-textprimary">Auto Assign Slot</span>
                        <ToggleSwitch checked={autoAssign} onChange={() => setAutoAssign(!autoAssign)} />
                    </div>

                    <h3 className="text-sm font-black text-[#0F172A] dark:text-textprimary uppercase tracking-wide">Parking Assignment</h3>
                    <p className="text-xs text-gray-400 mb-5">Assign a specific bay or allow system auto-allocation.</p>

                    <div>
                        <label className="block text-xs font-bold text-gray-700 dark:text-textprimary mb-2">
                            Assign Parking Slot <span className="text-red-500">*</span>
                        </label>
                        {autoAssign ? (
                            <div className="flex items-center justify-between p-3 bg-green-50 dark:bg-green-500/10 border border-green-200 dark:border-green-500/30 rounded-lg">
                                <div className="flex items-center gap-2">
                                    <span className="w-2 h-2 rounded-full bg-green-500"></span>
                                    <span className="text-xs font-bold text-gray-700 dark:text-textprimary">
                                        Auto-allocated Next Available Bay:
                                    </span>
                                    <span className="px-2 py-0.5 bg-green-100 dark:bg-green-500/20 text-green-700 dark:text-green-400 font-bold text-xs rounded">
                                        B1-021
                                    </span>
                                </div>
                                <span className="text-[10px] font-bold text-green-600 dark:text-green-400 uppercase tracking-wider">
                                    Basement 1 • Premium Access
                                </span>
                            </div>
                        ) : (
                            <input 
                                type="text"
                                placeholder="Enter Slot ID..."
                                className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dashboardbg border border-gray-200 dark:border-bordercolor rounded-lg text-sm focus:outline-none focus:border-blue-500 dark:text-textprimary placeholder-gray-300"
                            />
                        )}
                    </div>
                </div>

                {/* Access & Status */}
                <div className="p-5 border border-gray-200 dark:border-bordercolor rounded-xl bg-white dark:bg-cardbg">
                    <h3 className="text-sm font-black text-[#0F172A] dark:text-textprimary uppercase tracking-wide">Access & Status</h3>
                    <p className="text-xs text-gray-400 mb-5">Configure gate hardware verification permissions.</p>

                    <div className="grid grid-cols-2 gap-6">
                        <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-dashboardbg border border-gray-200 dark:border-bordercolor rounded-xl">
                            <div>
                                <p className="text-sm font-bold text-gray-800 dark:text-textprimary">Enable ANPR Camera Gate Pass</p>
                                <p className="text-xs text-gray-500 mt-0.5">Automated barrier opening on camera recognition</p>
                            </div>
                            <ToggleSwitch checked={anprEnabled} onChange={() => setAnprEnabled(!anprEnabled)} />
                        </div>

                        <div>
                            <label className="block text-xs font-bold text-gray-700 dark:text-textprimary mb-1.5">
                                Parking Status <span className="text-red-500">*</span>
                            </label>
                            <CustomSelect
                                options={[
                                    { label: "Active (Whitelisted)", value: "Active (Whitelisted)" },
                                    { label: "Suspended", value: "Suspended" }
                                ]}
                                value={parkingStatus}
                                onChange={setParkingStatus}
                            />
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <StepFooter
                    onNext={handleConfirm}
                    onPrev={() => navigate(-1)}
                    nextBtnText="Register Vehicle"
                />

            </div>
        </div>
    );
};

export default AddVehicle;
